import { Outlet } from "react-router-dom";

const LeadsParentPage = () => {
    return <Outlet />
}
export default LeadsParentPage;